import { useIsMobile } from 'common/hooks'
import { memo, useCallback, useMemo, useState } from 'react'
import { dateFormat } from 'utils/dates'
import { getAttributesNames } from 'utils/helpers'

import { IndividualDetailedAvatar } from '@/components/elements/images/individualDetailed'
import { IndividualsAvatarGroup } from '@/components/elements/images/individualsAvatarGroup'
import { TechnologiesAvatarGroup } from '@/components/elements/images/technologiesAvatarGroup'
import { Tags } from '@/components/elements/tags'
import { FixedHeight } from '@/components/elements/texts/fixedHeigh'
import RichText from '@/components/elements/texts/richText'
import WrapperMaxWidth from '@/components/elements/wrapperMaxWidth'
import Header from '@/components/shared/header'

import RelatedSeminar from './relatedSeminar'
import SeminarDetailsVideoContainer from './seminarDetailsVideoContainer'
import { TranscriptionsWidget } from '@/components/elements/transcriptions/transcriptionsWidget'
import { PlayerContextProvider } from 'common/contexts/playerContext'
import { isEmpty } from 'lodash'
import { mapRawSubtitles } from 'utils/subtitles'

const SeminarDetails = ({ seminarId, seminar }) => {
  const {
    title,
    content,
    video,
    cover,
    individuals,
    publish_date,
    categories,
    technologies,
    subtitles
  } = seminar
  const [transcriptionsOpened, setTranscriptionsOpened] = useState(false)
  const isMobile = useIsMobile()
  const date = new Date(publish_date)
  const formatDate = dateFormat.Month_D_Yr(date)

  const seminarCategories = getAttributesNames(categories)
  const individualsAvatar =
    individuals?.data?.length === 1 ? (
      <IndividualDetailedAvatar individual={individuals.data[0]} />
    ) : (
      <IndividualsAvatarGroup
        individuals={individuals.data}
        size="large"
        fontSize={1.8}
      />
    )
  const mappedSubtitles = useMemo(() => subtitles?.data?.map(mapRawSubtitles) ?? [], [subtitles])

  const handleOpenTranscriptions = useCallback(() => setTranscriptionsOpened(true), [setTranscriptionsOpened])
  const handleCloseTranscriptions = useCallback(() => setTranscriptionsOpened(false), [setTranscriptionsOpened])

  return (
    <>
      <Header />
      <WrapperMaxWidth>
        <div className="seminar-details-wrapper">
          <div className="seminar-details-video-wrapper">
          <PlayerContextProvider>
            <SeminarDetailsVideoContainer video={video} cover={cover.data[0].attributes} subtitles={mappedSubtitles} />
            { !isEmpty(mappedSubtitles) && <TranscriptionsWidget transcriptions={mappedSubtitles} opened={transcriptionsOpened} onClose={handleCloseTranscriptions} /> }
          </PlayerContextProvider>
          </div>
          <div className="seminar-details-container">
            <div className="seminar-details-content">
              <div className="seminar-details-title-header">
                <div className="seminar-details-title-container">
                  <div>
                    <div className="seminar-details-title">{title}</div>
                    <div className="seminar-details-date">{formatDate}</div>
                  </div>
                  <div className="seminar-details-group-wrapper">
                    <TechnologiesAvatarGroup
                      technologies={technologies.data}
                      className="seminar-details-technologies"
                      max={isMobile ? 2 : 5}
                    />
                    {!isEmpty(mappedSubtitles) && !transcriptionsOpened && (<>
                      <div className='vertical-separator' />
                      <div className='initiative-link'>
                        <p onClick={handleOpenTranscriptions}>
                          Show transcription
                        </p></div>
                      </>
                    )}
                  </div>
                </div>
                {individualsAvatar}
              </div>
              <div className="seminar-details-description">
                <FixedHeight height={isMobile ? 150 : 200}>
                  <RichText content={content} />
                </FixedHeight>
              </div>
            </div>
            <div className="seminar-details-related-seminars">
              <div className="seminar-details-related-seminars-title">
                Related Seminars
              </div>
              <Tags items={seminarCategories} className="seminar-details-tags" />
              <RelatedSeminar seminarId={seminarId} categories={categories.data} />
            </div>
          </div>
        </div>
      </WrapperMaxWidth>
    </>
  )
}

export default memo(SeminarDetails)
